import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";

const getAuthUser = async () => {
  try {
    const res = await baseAPI.get(`/get-profile`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    if (error) {
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      localStorage.removeItem("name");
      localStorage.removeItem("userType");
      window.location.reload();
    }
    console.log(error);
  }
};

const updateUserMerchantProfile = async (data) => {
  try {
    const formdata = new FormData();

    // Merchant Info
    formdata.append("name", data.name);
    formdata.append("company_name", data.company_name);
    formdata.append("email", data.email);
    formdata.append("mobile_number", data.mobile_number);
    formdata.append("category_id", data.category_id);
    // formdata.append("password", data.password);

    // National Address

    formdata.append("building_no", data.buildingNo);
    formdata.append("street", data.street);
    formdata.append("secondary_no", data.secondaryNo);
    formdata.append("district", data.district);
    formdata.append("postal_code", data.postalCode);
    formdata.append("national_address", data.nationalAddress);

    //Merchant Business Info.

    formdata.append(
      "commercial_registration_number",
      data.commercial_registration_number
    );
    formdata.append(
      "tax_identification_number",
      data.tax_identification_number
    );

    // Bank Details

    formdata.append("iban_number", data.ibanNumber);
    formdata.append("beneficiary_number", data.beneficiary_number);
    formdata.append("bank_name", data.bankName);
    // formdata.append("account_number", data.accountNumber);

    // Merchant Description

    formdata.append("description_en", data.description_ar);
    formdata.append("description_ar", data.description_ar);

    // Logo & Banner

    formdata.append("profile_image", data.profile_image);
    formdata.append("banner_image", data.banner_image);

    // Social Links

    formdata.append("instagram", data.instagram);
    formdata.append("twitter", data.twitter);
    formdata.append("facebook", data.facebook);

    formdata.append("district_id", data.district_id);
    formdata.append("address", data.address);
    formdata.append("latitude", data.latitude);
    formdata.append("longitude", data.longitude);


    const res = await baseAPI.post(`/update-merchant-profile`, data, {
      headers: authHeaderWithImage(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const updateUserBranchProfile = async (data) => {
  try {
    const formdata = new FormData();

    // Branch Info
    formdata.append("name", data.name);
    formdata.append("company_name", data.company_name);
    formdata.append("email", data.email);
    formdata.append("mobile_number", data.mobile_number);
    formdata.append("category_id", data.category_id);
    // formdata.append("password", data.password);

    formdata.append("profile_image", data.profile_image);
    formdata.append("banner_image", data.banner_image);

    formdata.append("short_address", data.short_address);
    formdata.append("country_id", data.country_id);
    // formdata.append("city_id", data.city_id);
    formdata.append("district_id", data.district_id);
    formdata.append("address", data.address);
    formdata.append("latitude", data.latitude);
    formdata.append("longitude", data.longitude);

    formdata.append("instagram", data.instagram);
    formdata.append("twitter", data.twitter);
    formdata.append("facebook", data.facebook);

    formdata.append("start_working_hour", data.start_working_hour);
    formdata.append("end_working_hour", data.end_working_hour);

    const res = await baseAPI.post(`/update-branch-profile`, data, {
      headers: authHeaderWithImage(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const merchantSendNotification = async (data) => {
  try {
    const formdata = new FormData();

    formdata.append("title", data.title);
    formdata.append("description", data.description);

    const res = await baseAPI.post(`/merchant-send-notification`, data, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getNotificationStatistics = async () => {
  try {
    const res = await baseAPI.get(`/merchant-send-notification-list`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getAllNotification = async () => {
  try {
    const res = await baseAPI.post(`/get-merchant-notification`, null, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    // if (error) {
    //   localStorage.removeItem("token");
    //   localStorage.removeItem("email");
    //   localStorage.removeItem("name");
    //   localStorage.removeItem("userType");
    //   window.location.reload();
    // }
    console.log(error);
  }
};

const UserService = {
  getAuthUser,
  updateUserMerchantProfile,
  updateUserBranchProfile,
  merchantSendNotification,
  getNotificationStatistics,
  getAllNotification
};
export default UserService;
